// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, Typography } from '@mui/material';

// project imports
import { gridSpacing } from 'store/constant';

// assets
import MainCard from 'ui/ui-component/cards/MainCard';
import ServicesCard from 'ui/ui-component/cards/ServicesCard';
import saServices from './sa-services';
import { Helmet } from 'react-helmet-async';
// ==============================|| CONTACT CARD ||============================== //

const SAServicesHomePage = () => {
    const theme = useTheme();

    let saServicesResult = <></>;
    if (saServices) {
        saServicesResult = saServices.map((service, index) => (
            <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
                <ServicesCard {...service} />
            </Grid>
        ));
    }

    return (
        <>
            <Helmet>
                <title>Prepaid Services (SA) - Simplex Solutions</title>
                <link rel="canonical" href={`/services/south-africa/`} />
                <meta name="description" content="Prepaid Services (SA)" />
            </Helmet>

            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <MainCard
                        title={
                            <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                                <Grid item>
                                    <Typography variant="h3">Prepaid Services (SA)</Typography>
                                </Grid>
                            </Grid>
                        }
                    >
                        <Grid container spacing={gridSpacing}>
                            <Grid className="block" item xs zeroMinWidth sx={{ display: 'flex' }}>
                                <Grid container alignItems="center" spacing={gridSpacing}>
                                    <Grid item xs={12}>
                                        <Grid container direction="row" spacing={gridSpacing}>
                                            {saServicesResult}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MainCard>
                </Grid>
            </Grid>
        </>
    );
};

export default SAServicesHomePage;
